import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment';

import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from "../../config/config";
import {useState} from "react";
import useIsMobile from "../../hooks/useIsMobile";

const ResponseBubble = props => {
  const [markedUnread, setMarkedUnread] = useState(false);
  const isMobile = useIsMobile();
  return (
    <Stack sx={{
      padding: {xs: '8px 6% 0 0', sm: '8px 19% 0 0'},
      alignItems: 'flex-start',
      gap: '8px'
    }}>
      <Box className='message-history-block-message-content'
           borderRadius={'8px 8px 8px 0'}
           backgroundColor={config().colors.light2}>
        <Typography 
          variant={isMobile ? 'small500Inter' : 'large500TightInter'}
          style={{whiteSpace: 'pre-line'}}
        >
          {get(props, 'message.message')}
        </Typography>
      </Box>
      <Stack className='message-history-block-message-content-time'>
        {props.message.is_read && !markedUnread
          ? <Button
            size='sm'
            sx={{padding: '0 8px', lineHeight: 1}}
            onClick={() => {
              setMarkedUnread(true);
              props.onMarkUnread(props.message.id);
            }}
          >
            <Typography variant='small'>
              Mark Unread
            </Typography>
          </Button>
          : null
        }
        <Typography variant='smallSemiBoldTightInter' color='text.light' className='message-history-block-send-date'>
          {moment(get(props, 'message.date_sent')).format('h:mm a')}
        </Typography>
      </Stack>
    </Stack>
  );
};

ResponseBubble.propTypes = {
  message: PropTypes.object,
};

export default ResponseBubble;
